import { render, staticRenderFns } from "./SysDialogDelete.vue?vue&type=template&id=b8c0ebd6"
import script from "./SysDialogDelete.vue?vue&type=script&lang=js"
export * from "./SysDialogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports